
export default {
  name: 'ProductDetailSection',

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    company: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      activeItemId: 0
    };
  },

  // call focus to the first title-wrapper and unfocus
  // make it in mounted()
  // as a workaround for safari line-break issue?
  mounted() {
    const activeTitleElement = this.$refs.sectiontitles?.querySelector('.title-wrapper.active');

    activeTitleElement.focus();
    this.$nextTick(() => {
      activeTitleElement.blur();
    });
  },

  methods: {
    toggleActiveItem(value) {
      this.activeItemId = value;
    }
  }
};
